import { render } from "./TrailerCreatePage.vue?vue&type=template&id=4e77be5c"
import script from "./TrailerCreatePage.vue?vue&type=script&lang=js"
export * from "./TrailerCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__